export const getStorageAccessRequired = () =>
  'requestStorageAccess' in document && 'hasStorageAccess' in document;

export const requestCookieAccess = (onStorageAccessRejected: () => void): Promise<boolean> =>
  new Promise((resolve, reject) =>
    document
      .requestStorageAccess()
      .then(
        () => {
          resolve(true);
          return;
        },
        // Important: don't move this to async/await or catch.
        // It will break the ability to open the popup conditionally.
        // See - https://stackoverflow.com/questions/62763056/requeststorageaccess-launch-popup-window-if-denied-access
        () => {
          onStorageAccessRejected();
          resolve(false);
        },
      )
      .catch(reject),
  );
